import { render, staticRenderFns } from "./KycCountryButton.vue?vue&type=template&id=224274a4&scoped=true&"
import script from "./KycCountryButton.vue?vue&type=script&lang=js&"
export * from "./KycCountryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224274a4",
  null
  
)

export default component.exports